import { createApp, nextTick } from 'vue'
import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import Aura from '@primevue/themes/aura'
import VueClipboard from 'vue3-clipboard'
import { Tooltip } from 'primevue'
import 'primeicons/primeicons.css'

// PrimeVue компоненты
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Tag from 'primevue/tag'
import Toast from 'primevue/toast'
import Dropdown from 'primevue/dropdown'

import { pinia } from '@/store'
import { useAuthStore } from '@/store/auth'

async function initApp() {
  const app = createApp(App)

  app.use(pinia)

  const authStore = useAuthStore()
  authStore.init()

  await nextTick()

  app
    .use(router)
    .use(PrimeVue, {
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: true
        }
      }
    })
    .use(ToastService)
    .use(VueClipboard, {
      autoSetContainer: true,
      appendToBody: true
    })

  // <<< регистрация директивы
  app.directive('tooltip', Tooltip)

  // Регистрация компонентов PrimeVue
  app.component('DataTable', DataTable)
  app.component('Column', Column)
  app.component('Button', Button)
  app.component('Dialog', Dialog)
  app.component('InputText', InputText)
  app.component('InputNumber', InputNumber)
  app.component('Tag', Tag)
  app.component('Toast', Toast)
  app.component('Dropdown', Dropdown)

  app.mount('#app')
}

// Запускаем инициализацию
initApp()
